import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

/** Anasayfa kartları ve /forum/:id detayında ortak tarih metni. */
export function formatLastUpdated(dateString: string | null | undefined): string {
  if (!dateString) return 'Henüz güncellenmedi';
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return 'Henüz güncellenmedi';
    const now = new Date();
    const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60));

    if (diffInHours < 1) return 'Az önce';
    if (diffInHours < 24) return `${diffInHours}s önce`;
    if (diffInHours < 48) return 'Dün';
    return format(date, 'dd MMM', { locale: tr });
  } catch {
    return 'Henüz güncellenmedi';
  }
}

export function lastUpdatedSource(forum: {
  updated_at?: string | null;
  created_at?: string | null;
}): string | null | undefined {
  return forum.updated_at || forum.created_at;
}

/** Sitede forum kaydının oluşturulma tarihi (created_at). */
export function formatSiteAddedDate(dateString: string | null | undefined): string {
  if (!dateString) return 'Bilinmiyor';
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return 'Bilinmiyor';
    return format(date, 'd MMMM yyyy', { locale: tr });
  } catch {
    return 'Bilinmiyor';
  }
}

/** Admin tabloları: göreli metin + tam tarih/saat. */
export function formatLastUpdatedAdmin(dateString: string | null | undefined): string {
  const relative = formatLastUpdated(dateString);
  if (!dateString || relative === 'Henüz güncellenmedi') return relative;
  try {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return relative;
    return `${relative} (${format(date, 'dd.MM.yyyy HH:mm', { locale: tr })})`;
  } catch {
    return relative;
  }
}
